import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getBrands(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ecoupon/get_brands', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getBrand(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/ecoupon/get_brand/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addBrand(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/ecoupon/add_brand', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editBrand(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/ecoupon/edit_brand/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBrand(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/ecoupon/delete_brand/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
